import { gql } from "@apollo/client";

const UpdatePhotoGeom = gql`
  mutation updatePhotoGeom($uploadId: BigInt!) {
    updatePhotoGeom(input: { tupload: $uploadId }) {
      boolean
    }
  }
`;

const hash = "e533d168a39ba6385e7d8e5be3427f49367be0aa4c161dad0384916e59347b6f";

export { UpdatePhotoGeom, hash };
